import { Modal } from '@innovationdepartment/proxima-ui';
import JoinConfirmationView from './JoinConfirmation.View';

export type JoinConfirmationProps = {
  open: boolean;
  close: () => void;
  confirm: () => void;
  brandName: string;
  isLoading?: boolean;
};

const JoinConfirmation = ({
  open,
  confirm,
  close,
  brandName,
  isLoading
}: JoinConfirmationProps) => (
  <Modal
    noPadding={false}
    open={open}
    title="Add yourself to brand"
    onClose={close}
    allowCloseOnClickOutside
  >
    <JoinConfirmationView
      confirm={confirm}
      close={close}
      brandName={brandName}
      isLoading={isLoading}
    />
  </Modal>
);

export default JoinConfirmation;
